import { render } from "./Kids.vue?vue&type=template&id=ebe9a0a4&scoped=true"
import script from "./Kids.vue?vue&type=script&lang=js"
export * from "./Kids.vue?vue&type=script&lang=js"

import "./Kids.vue?vue&type=style&index=0&id=ebe9a0a4&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe9a0a4"]])

export default __exports__